module.exports = __webpack_public_path__ + "img/home-v2-4.891278fa.jpg";